import { Link } from 'react-router-dom'
import {
  DIRECTIONS,
  getRelationshipType,
  getDirection,
  getDirectionSymbol,
  getRelationshipColor
} from '../../lib/relationshipTypes'
import './RelationshipWeb.css'

export default function RelationshipWeb({ relationships = [], allCharacters = [], showHidden = false }) {
  // Filter out hidden relationships for non-admin view
  const visibleRelationships = showHidden
    ? relationships
    : relationships.filter(rel => !rel.hidden)

  if (!visibleRelationships || visibleRelationships.length === 0) {
    return null
  }

  const getCharacter = (id) => {
    return allCharacters.find(c => c.id === id)
  }

  // Group relationships by direction
  const grouped = {
    from: [],
    to: [],
    mutual: [],
    self: []
  }

  visibleRelationships.forEach(rel => {
    const dir = rel.direction || 'to'
    if (grouped[dir]) {
      grouped[dir].push(rel)
    } else {
      grouped.to.push(rel)
    }
  })

  // Direction display order and labels
  const directionOrder = [
    { id: 'from', label: 'From Them', symbol: '←', description: 'They feel this toward me' },
    { id: 'to', label: 'To Them', symbol: '→', description: 'I feel this toward them' },
    { id: 'mutual', label: 'Mutual', symbol: '↔', description: 'Both ways' },
    { id: 'self', label: 'Self', symbol: '⟳', description: 'Self-referential' }
  ]

  return (
    <div className="relationship-web">
      {directionOrder.map(dir => {
        const rels = grouped[dir.id]
        if (!rels || rels.length === 0) return null

        return (
          <div key={dir.id} className="web-group">
            <h4 className="web-group-header">
              <span className="web-direction-symbol">{dir.symbol}</span>
              <span className="web-direction-label">{dir.label}</span>
            </h4>

            <div className="web-connections">
              {rels.map((rel, index) => {
                const target = getCharacter(rel.targetId)
                const type = getRelationshipType(rel.type)

                if (!target) {
                  return (
                    <div key={index} className="web-connection unknown">
                      <span className="web-target-name">Unknown Character</span>
                    </div>
                  )
                }

                return (
                  <Link
                    key={index}
                    to={`/characters/${target.id}`}
                    className="web-connection"
                    style={{ '--rel-color': getRelationshipColor(rel.type) }}
                  >
                    <div className="web-connection-content">
                      <span className="web-target-name">{target.name}</span>
                      <span
                        className="web-type-badge"
                        style={{ backgroundColor: getRelationshipColor(rel.type) }}
                      >
                        {type?.label || rel.type}
                      </span>
                    </div>
                    {rel.notes && (
                      <p className="web-notes">{rel.notes}</p>
                    )}
                  </Link>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}
